<template>
    <div class="col props-group">
        <el-form-item label="列数">
          <el-input/>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'attr-col',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
  .col {
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/col.vue